/// <amd-module name="Environments/Landing/Stores/EnvironmentsStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { EnvironmentsActions } from "Environments/Landing/Actions/EnvironmentsActions";
import { IEnvironmentsResult, IEnvironmentObject } from "Environments/Client/EnvironmentContracts";
import { StoreBase } from "Environments/Flux/Store"

export interface IEnvironmentsState {
    environments: IEnvironmentObject[];
    continuationToken: string;
}

export class EnvironmentsStore extends StoreBase {

    public static getKey(): string {
        return "environments-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        this._state = {
            environments: [],
            continuationToken: ""
        }

        this._actionsHub = ActionsHubManager.GetActionsHub<EnvironmentsActions>(EnvironmentsActions, instanceId);
        this._actionsHub.setEnvironments.addListener(this._handleSetEnvironments);
        this._actionsHub.appendEnvironments.addListener(this._handleAppendEnvironments);
    }

    public getState(): IEnvironmentsState {
        return this._state;
    }

    public getEnvironments(): IEnvironmentObject[] {
        return this._state.environments ? this._state.environments : [];
    }
    
    protected disposeInternal(): void {
        this._actionsHub.setEnvironments.removeListener(this._handleSetEnvironments);
        this._actionsHub.appendEnvironments.removeListener(this._handleAppendEnvironments);
    }

    private _handleSetEnvironments = (environmentsResult: IEnvironmentsResult) => {
        if (environmentsResult) {
            this._state = {
                environments: environmentsResult.environments ? environmentsResult.environments : [],
                continuationToken: environmentsResult.continuationToken
            } as IEnvironmentsState;
            
            this.emitChanged();
        }
    }

    private _handleAppendEnvironments = (environmentsResult: IEnvironmentsResult) => {
        if (environmentsResult && environmentsResult.environments) {
            this._state.environments = this._state.environments.concat(environmentsResult.environments);
            this._state.continuationToken = environmentsResult.continuationToken;
            this.emitChanged();
        }
    }

    private _actionsHub: EnvironmentsActions;
    private _state: IEnvironmentsState;
}
